// extracted by mini-css-extract-plugin
export default {"columnsContainer":"ProfileLikedPage_columnsContainer__h7F2W","loaderWrapper":"ProfileLikedPage_loaderWrapper__4idod","loader":"ProfileLikedPage_loader__fsfhn"};